import axios from 'axios';
import { API_URL } from '@/config';

export default {

  list() {
    return axios.get(`${API_URL}/vcloud/pools`);
  },

  vms() {
    return axios.get(`${API_URL}/vcloud/pools-vms`);
  },

  vm(params) {
    return axios.post(`${API_URL}/vcloud/pools-vm`, params);
  },

  edge(params) {
    return axios.get(`${API_URL}/vcloud/pools-edge`, {params});
  },

  edges() {
    return axios.get(`${API_URL}/vcloud/pools-edges`);
  },

  export() {
    window.open(`${API_URL}/vcloud/export?extension=csv`, '_blank');
  },

  exportEdges() {
    window.open(`${API_URL}/vcloud/export-edges?extension=csv`, '_blank');
  },

  login(userForm) {
    return axios.post(`${API_URL}/vcloud/login`, userForm);
  },
  listHosts() {
    return axios.get(`${API_URL}/vcloud/hosts`);
  }
};
